export const IMAGE = {
  src: "https://imagedelivery.net/5u-BnzY4d8R245ADRh1vnA/5580d1bc-c0c6-4dc7-5ef2-86aeeaf79500/public",
};
export const VIDEO = {
  src: "https://customer-ji7awdm9ojrzi8s9.cloudflarestream.com/c120e15a76cbf640ea80e9e549d76969/manifest/video.m3u8",
  autoPlay: true,
  playsInline: true,
};

export const ROUTES = {
  home: "/",
  dashboard: "/dashboard",
  login: "/login",
  logout: "/logout",
  recover: "/recover",
  reset: "/reset",
  account: {
    edit: "/dashboard/account/edit",
    security: "/dashboard/account/security",
  },
  classes: {
    create: "/dashboard/classes/create",
  },
  sessions: {
    create: "/dashboard/sessions/create",
  },
  join: "/join",
  checkpoint: "/checkpoint",
  api: {
    v1: {
      answer: {
        submitMultiple: "/api/v1/answer/submitMultiple",
      },
    },
  },
};

export const WALKTHROUGH = [
  {
    media: {
      image: {
        src: "https://imagedelivery.net/5u-BnzY4d8R245ADRh1vnA/67275903-18e3-4613-5f4f-5fc30e30f200/public",
      },
    },
    title: "Welcome to Journi!",
    text: "Read on for some helpful tips on how to get the best out of the experience.",
  },
  {
    media: {
      image: {
        src: "https://imagedelivery.net/5u-BnzY4d8R245ADRh1vnA/22e0d6eb-fc83-4090-3601-fa83acc10500/public",
      },
    },
    title: "Are you listening?",
    text: "Journi’s designed to be enjoyed with sound ON. (But we do have closed captions too!)",
  },
  {
    media: {
      image: {
        src: "https://imagedelivery.net/5u-BnzY4d8R245ADRh1vnA/bc134c76-e6fe-40a8-4e47-a0ace8b9b900/public",
      },
    },
    title: "Get connected",
    text: "Using a digital whiteboard? Connect to your laptop or device for the best experience.",
  },
  {
    media: {
      image: {
        src: "https://imagedelivery.net/5u-BnzY4d8R245ADRh1vnA/0cd190f0-b4fe-4072-aa46-05da433bd900/public",
      },
    },
    title: "Choose your method",
    text: "Modules can be teacher-led, completed in groups or individually. Feel free to change it up as you go.",
  },
  {
    media: {
      image: {
        src: "https://imagedelivery.net/5u-BnzY4d8R245ADRh1vnA/7ab27b7b-1b25-4f45-90e6-07e71b7a1900/public",
      },
    },
    title: "Continue the learning",
    text: "Expand the experience with curriculum-aligned offline resources and early finisher ideas.",
  },
];

export const cloudflareTurnstile = {
  siteverify: "https://challenges.cloudflare.com/turnstile/v0/siteverify",
};
